<ng-container *ngIf="multiple; else single">
    <dx-tag-box #multipleTagsBox
                [acceptCustomValue]="true"
                [dataSource]="employees"
                [displayExpr]="displayName"
                [placeholder]="'employeePicker.search' | translate"
                [noDataText]="'_pickers.lblStartSearch' | translate"
                [openOnFieldClick]="false"
                [readOnly]="readOnly"
                [searchExpr]="['displayName', 'email']"
                [searchEnabled]="false"
                [showClearButton]="true"
                [showDataBeforeSearch]="false"
                [value]="selectedItems"
                (valueChange)="onMultipleValueChange($event)"
                (onKeyUp)="onSearchFilterChanged($event)"
                [(text)]="searchFilter"
                itemTemplate="item">
        <div *dxTemplate="let data of 'item'">
            <div style="display: flex; align-items: center;">
                <div class="employeePhotoContainer"><img class="employeePhoto" src="{{data.photo}}" alt="{{data.displayName}}" /></div>
                <div class="right">
                    <div class="displayName">{{data.displayName}}</div>
                    <div class="jobTitle">{{data.jobTitle}}</div>
                </div>
            </div>
        </div>
        <dx-validator>
            <dxi-validation-rule *ngIf="isRequired"
                                 type="required"
                                 [message]="'_pickers.msgEmployeeRequired' | translate">
            </dxi-validation-rule>
        </dx-validator>
    </dx-tag-box>
</ng-container>
<ng-template #single>
    <dx-select-box #singleTagBox
                   [acceptCustomValue]="true"
                   [dataSource]="employees"
                   [displayExpr]="displayName"
                   [placeholder]="'employeePicker.search' | translate"
                   [noDataText]="'_pickers.lblStartSearch' | translate"
                   [openOnFieldClick]="false"
                   [readOnly]="readOnly"
                   [searchExpr]="['displayName', 'email']"
                   [searchEnabled]="false"
                   [showClearButton]="true"
                   [showDataBeforeSearch]="false"
                   [value]="selectedItems"
                   (valueChange)="onSingleValueChange($event)"
                   (onKeyUp)="onSearchFilterChanged($event)"
                   [(text)]="searchFilter"
                   itemTemplate="item">
        <div *dxTemplate="let data of 'item'">
            <div style="display: flex; align-items: center;">
                <div class="employeePhotoContainer"><img class="employeePhoto" src="{{data.photo}}" alt="{{data.displayName}}" /></div>
                <div class="right">
                    <div class="displayName">{{data.displayName}}</div>
                    <div class="jobTitle">{{data.jobTitle}}</div>
                </div>
            </div>
        </div>
        <dx-validator>
            <dxi-validation-rule *ngIf="isRequired"
                                 type="required"
                                 [message]="'_pickers.msgEmployeeRequired' | translate">
            </dxi-validation-rule>
        </dx-validator>
    </dx-select-box>
</ng-template>
